const CDN = "https://for-media.b-cdn.net/ozgurmd";

const BOOKS = [
  {
    slug: "grabbing-life-by-the-horns",
    id: "horns",
    title: "Grabbing Life by the Horns",
    detailTitle:
      "Grabbing Life by the Horns — and other patient stories of a neurosurgeon",
    detailFormatLine: "Paperback · September 22, 2022",
    subtitle: "A patient and neurosurgeon's remarkable journey",
    author: "Burak M. Ozgur",
    rating: 4.7,
    reviews: 9,
    pages: 164,
    published: "September 22, 2022",
    publisher: "Light Network",
    genre: "Memoir · Nonfiction",
    image: `${CDN}/grabbing-life-by-the-horns-cover-front.jpg`,
    description:
      "What does a would-be horn implant candidate, an accused serial killer, and a woman coveting her mother's spine all have in common? They've all turned to top US neurosurgeon Dr. Burak M Ozgur for help. In this collection of touching, peculiar, and sometimes downright funny stories, Dr. Ozgur recounts some of his most unique and memorable patient experiences. For almost two decades, patients have entrusted their lives to Dr. Ozgur, and it's something he considers both an honor and a privilege. Prepare to be captivated as Dr. Ozgur shares his understanding and insights about the fascinating complexity of the human brain, and the resilience of the human spirit.",
    kindle:
      "https://www.amazon.com/Grabbing-Life-Horns-patient-neurosurgeon-ebook/dp/B0BH8WVX9B/ref=tmm_kin_swatch_0",
    paperback:
      "https://www.amazon.com/Grabbing-Life-Horns-patient-neurosurgeon/dp/B0BCDLGB24/ref=tmm_pap_swatch_0",
    sample: "https://read.amazon.com/sample/B0BH8WVX9B?clientId=share",
    formatLabel: "Paperback",
    gradient: ["#d4a574", "#c4956a", "#e8c9a8"],
    productDetails: [
      { label: "Print length", value: "164 pages" },
      { label: "Language", value: "English" },
      { label: "Publisher", value: "Light Network" },
      { label: "Publication date", value: "September 22, 2022" },
      { label: "Dimensions", value: "5 x 0.38 x 8 inches" },
      { label: "ISBN-13", value: "979-8985062755" },
      { label: "Item weight", value: "6.4 ounces" },
    ],
  },
  {
    slug: "pugslys-idea-goes-viral",
    id: "pugsly",
    title: "Pugsly\u2019s Idea Goes Viral",
    detailTitle: "Pugsly\u2019s Idea Goes Viral",
    detailFormatLine: "Kindle Edition · October 13, 2024",
    subtitle: "A children\u2019s story about big ideas and even bigger dreams",
    author: "Burak Ozgur",
    rating: 5.0,
    reviews: null,
    pages: 207,
    published: "October 13, 2024",
    publisher: "Your Book Angel",
    genre: "Children\u2019s Fiction",
    image: `${CDN}/pugsly-cover.jpg`,
    description:
      "Life couldn't be better for our charming pug-tagonist and his quirky petmates until a group of raccoons shares a startling revelation about humans. Determined to keep his beloved owners safe at home, Pugsly orchestrates a mischievous plan with the help of neighborhood animals. But when the scheme backfires, seemingly unleashing an unexpected global pandemic, Pugsly must navigate guilt, redemption, and a troublesome bird named Klaus.\n\nWill Pugsly be able to restore balance to both the human and animal worlds?\n\nJoin him on a heartwarming journey of self-discovery, friendship, and the enduring bond between humans and their furry friends in this delightful tale.",
    kindle:
      "https://www.amazon.com/Pugslys-Idea-Viral-Burak-Ozgur-ebook/dp/B0DJZTWZM2/ref=sr_1_2",
    paperback:
      "https://www.amazon.com/Pugslys-Idea-Viral-Burak-Ozgur/dp/B0DJ49FJC3/ref=tmm_pap_swatch_0",
    sample: "https://read.amazon.com/sample/B0DJZTWZM2?clientId=share",
    formatLabel: "Paperback",
    gradient: ["#7eb8d8", "#a8d4e8", "#5a9cbf"],
    productDetails: [
      { label: "Reading age", value: "8\u201312 years" },
      { label: "Print length", value: "207 pages" },
      { label: "Language", value: "English" },
      { label: "Publisher", value: "Your Book Angel" },
      { label: "Publication date", value: "October 13, 2024" },
    ],
  },
  {
    slug: "minimally-invasive-spine-surgery",
    id: "spine",
    title: "Minimally Invasive Spine Surgery",
    detailTitle:
      "Minimally Invasive Spine Surgery: A Practical Guide to Anatomy and Techniques",
    detailFormatLine: "2009th Edition · Kindle Edition · October 8, 2009",
    subtitle: "Techniques, Evidence, and Controversies",
    author: "Burak Ozgur, Edward Benzel, Steven Garfin",
    rating: 5.0,
    reviews: 2,
    pages: 555,
    published: "October 8, 2009",
    publisher: "Springer",
    genre: "Medical · Neurosurgery",
    image: `${CDN}/minimally-invasive-spine-surgery.jpg`,
    description:
      "Minimally Invasive Spine Surgery is a beautifully illustrated atlas describing the 18 most widely accepted minimally invasive procedures in spine surgery. Written by leaders in both neurologic and orthopedic spine surgery, this book offers the most up-to-date material and the broadest perspective on the subject. Procedures range from simple to complex and cover the cervical, thoracic and lumbar regions of the spine.",
    kindle:
      "https://www.amazon.com/Minimally-Invasive-Spine-Surgery-Techniques-ebook/dp/B008BAILF2/ref=sr_1_3",
    paperback:
      "https://www.amazon.com/Minimally-Invasive-Spine-Surgery-Techniques/dp/0387898301/ref=tmm_hrd_swatch_0",
    sample: null,
    formatLabel: "Hardcover",
    gradient: ["#8faabe", "#a8c0d0", "#6b8da8"],
    productDetails: [
      { label: "ISBN-13", value: "978-0387898315" },
      { label: "Edition", value: "2009th" },
      { label: "Publisher", value: "Springer" },
      { label: "Publication date", value: "October 8, 2009" },
      { label: "Language", value: "English" },
      { label: "Print length", value: "555 pages" },
    ],
    editorialReviews: [
      {
        quote:
          "This monograph is both a textbook and atlas on the subject of lumbar disc disease. \u2026 This book is meant for neurosurgeons and orthopaedics specialists. I happily recommend it to those audiences exclusively as well as to medical students and residents.",
        source: "Joseph J. Grenier, Amazon.com, January 2014",
      },
      {
        quote:
          "Spine surgery has evolved significantly over the past 40 years. \u2026 This book explores the concept further and provides a practical guide. \u2026 Neurosurgeons and orthopedic surgeons are the intended readers. \u2026 This is a good book on the anatomy, basic concepts, and techniques of minimally invasive spine surgery. It should belong to neurosciences libraries and practices involved in spine surgery.",
        source: "Celso Agner, Doody's Review Service, April 2010",
      },
    ],
  },
];

export default BOOKS;
